import { onBeforeMount, onBeforeUnmount, ref } from 'vue'
import { usePageContext } from '../renderer/usePageContext'
import { watchIgnorable } from '@vueuse/core'

export function usePagination() {
  const page = ref({
    number: 1,
    size: 20,
    totalElements: 0,
    totalPages: 0,
  })

  const pageContext = usePageContext()

  const { ignoreUpdates } = watchIgnorable(
    () => page.value.number,
    () => {
      const url = new URL(window.location.href)
      const params = new URLSearchParams(url.search)

      params.set('page', page.value.number)

      const newURL = `${url.pathname}?${params.toString()}${url.hash}`
      // Update the URL without refreshing the page
      history.pushState(null, '', newURL)
    },
  )

  onBeforeMount(() => {
    window.addEventListener('popstate', getPageFromURL)
  })

  onBeforeUnmount(() => {
    window.removeEventListener('popstate', getPageFromURL)
  })

  function getPageFromURL() {
    const url = pageContext.isClientSide
      ? new URL(window.location.href)
      : new URL(`https://${pageContext.hostname}${pageContext.urlOriginal}`)
    const params = new URLSearchParams(url.search)

    ignoreUpdates(() => {
      page.value.number = parseInt(params.get('page')) || 1
    })
  }

  getPageFromURL()

  return {
    page,
  }
}
